(() => {
  function init(root) {
    if (root.dataset.lpReady) return;
    root.dataset.lpReady = 'true';
    const form = root.querySelector('.lp-form');
    const gallery = root.querySelector('[data-lp-gallery]');
    const priceNodes = root.querySelectorAll('[data-lp-price]');
    const selectionNodes = root.querySelectorAll('[data-lp-selection]');
    const sticky = root.querySelector('[data-lp-sticky]');
    if (!form) return;
    form.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
      const buy = form.querySelector('button[name="add"]');
      if (buy) buy.disabled = input.disabled;
      const buyLabel = root.querySelector('[data-lp-buy-label]');
      if (buyLabel) buyLabel.textContent = input.disabled ? 'Indisponible' : 'Ajouter au panier';
      priceNodes.forEach(n => { n.textContent = input.dataset.price; });
      selectionNodes.forEach(n => { n.textContent = input.dataset.title; });
      if (gallery && input.dataset.image) {
        gallery.src = input.dataset.image;
        gallery.removeAttribute('srcset');
        gallery.alt = input.dataset.imageAlt || input.dataset.title;
      }
      const caption = root.querySelector('[data-lp-gallery-caption]');
      if (caption) caption.textContent = input.dataset.title;
      root.querySelector('[data-lp-contents]').textContent = input.dataset.recharge === 'true'
        ? 'Recharge seule : le pommeau et les accessoires ne sont pas inclus.'
        : 'Kit complet. Le nombre de filtres correspond au kit sélectionné.';
      if (location.pathname.includes('/products/')) {
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    });
    root.querySelectorAll('[data-lp-refill-link]').forEach(link => {
      link.addEventListener('click', () => {
        const details = root.querySelector('.lp-refill');
        if (details) details.open = true;
        const radio = details?.querySelector('input:not(:disabled)');
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    root.querySelectorAll('[data-lp-photo]').forEach(button => {
      button.addEventListener('click', () => {
        gallery.src = button.dataset.lpPhoto;
        gallery.removeAttribute('srcset');
        gallery.alt = button.dataset.alt;
        root.querySelectorAll('[data-lp-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        root.querySelector('[data-lp-gallery-caption]').textContent = button.dataset.alt;
      });
    });
    if (sticky && 'IntersectionObserver' in window) {
      let belowHero = false, orderVisible = false;
      const update = () => { sticky.hidden = !belowHero || orderVisible; };
      new IntersectionObserver(entries => {
        belowHero = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        update();
      }).observe(root.querySelector('.lp-hero'));
      new IntersectionObserver(entries => { orderVisible = entries[0].isIntersecting; update(); }).observe(form);
    }
  }
  document.querySelectorAll('[data-lp-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-lp-root]').forEach(init);
  });
})();